// src/api/vehicles.js
import { requestJson } from './http';

// Fetch all vehicles
export function getVehicles() {
  return requestJson('/vehicles');
}

// Fetch a single vehicle by id
export function fetchVehicle(id) {
  return requestJson(`/vehicles/${id}`);
}

// Create a new vehicle
export function createVehicle(vehicleData) {
  return requestJson('/vehicles', {
    method: 'POST',
    body: vehicleData,
  });
}

// Update a vehicle
export function updateVehicle(id, updates) {
  return requestJson(`/vehicles/${id}`, {
    method: 'PUT',
    body: updates,
  });
}

// Delete a vehicle
export async function deleteVehicle(id) {
  await requestJson(`/vehicles/${id}`, {
    method: 'DELETE',
    expectJson: false,
  });
}

export async function lookupVehicleByVRM(vrm) {
  return await requestJson(`/vehicles/lookup/${vrm}`);
}

// Update phv timestamps for a vehicle
export async function updateVehicleDates(vrm, body) {
  return await requestJson(`/vehicles/${encodeURIComponent(vrm)}/dates`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}
